export const categories = [
  {
    id: 'hd',
    name: '高清超清',
    slug: 'hd',
    icon: 'ri-4k-line',
    description: '汇聚4K/8K超清画质平台，为您推荐画质最出色的欧美无码正版平台，追求极致视觉体验。',
    image: 'https://readdy.ai/api/search-image?query=4K%20ultra%20HD%20cinematic%20display%20dark%20elegant%20ambient%20lighting%20sophisticated%20minimalist%20professional%20editorial%20photography%20luxurious%20dark%20atmosphere&width=800&height=500&seq=category-hd&orientation=landscape',
    count: 5,
  },
  {
    id: 'vr',
    name: 'VR虚拟现实',
    slug: 'vr',
    icon: 'ri-glasses-line',
    description: '专注于VR沉浸式体验平台，从8K全景到互动剧情，带您进入全新的虚拟世界。',
    image: 'https://readdy.ai/api/search-image?query=VR%20headset%20on%20dark%20futuristic%20desk%20ambient%20neon%20lighting%20sophisticated%20minimalist%20professional%20editorial%20photography%20elegant&width=800&height=500&seq=category-vr&orientation=landscape',
    count: 1,
  },
  {
    id: 'live',
    name: '直播互动',
    slug: 'live',
    icon: 'ri-live-line',
    description: '实时互动直播平台推荐，与全球主播实时交流，体验不一样的社交互动乐趣。',
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20dark%20ambient%20professional%20lighting%20sophisticated%20minimalist%20elegant%20editorial%20photography&width=800&height=500&seq=category-live&orientation=landscape',
    count: 1,
  },
  {
    id: 'classic',
    name: '经典珍藏',
    slug: 'classic',
    icon: 'ri-film-line',
    description: '收录经典年代欧美无码影片，经过AI修复重现高清画质，为怀旧爱好者打造专属珍藏。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20on%20dark%20wooden%20desk%20warm%20copper%20lighting%20elegant%20sophisticated%20nostalgic%20editorial%20photography%20minimalist&width=800&height=500&seq=category-classic&orientation=landscape',
    count: 1,
  },
  {
    id: 'mobile',
    name: '移动端优化',
    slug: 'mobile',
    icon: 'ri-smartphone-line',
    description: '专为移动设备优化的欧美无码平台，提供流畅的手机观影体验，支持离线下载与智能省流。',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20on%20dark%20desk%20elegant%20ambient%20lighting%20sophisticated%20minimalist%20professional%20editorial%20photography%20modern%20dark%20atmosphere&width=800&height=500&seq=category-mobile&orientation=landscape',
    count: 1,
  },
  {
    id: 'guide',
    name: '使用指南',
    slug: 'guide',
    icon: 'ri-guide-line',
    description: '全面的欧美无码平台使用指南，包括安全访问、VPN推荐、设备选购和订阅技巧等实用内容。',
    image: 'https://readdy.ai/api/search-image?query=Open%20guide%20book%20on%20dark%20desk%20warm%20gold%20lighting%20elegant%20sophisticated%20editorial%20photography%20minimalist%20professional%20luxurious&width=800&height=500&seq=category-guide&orientation=landscape',
    count: 3,
  },
];